import styled from 'styled-components';

const HeaderAction = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin-right: 18px;
  flex-grow: 1;
`;
export default HeaderAction;
